import { render, staticRenderFns } from "./ProfileCart.vue?vue&type=template&id=0ae11269&scoped=true"
import script from "./ProfileCart.vue?vue&type=script&lang=ts"
export * from "./ProfileCart.vue?vue&type=script&lang=ts"
import style0 from "./ProfileCart.vue?vue&type=style&index=0&id=0ae11269&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae11269",
  null
  
)

export default component.exports